import cn from "classnames"

import { isNA, isScanning } from "@/domain/scan-history"
import { ShowMore } from "@/molecules/ShowMore"

import styles from "./ScanDate.module.scss"

import type { TFunction } from "@/hooks/useTranslation"
import type { getScanHistorySelector } from "@/pages/GovernancePage/applications/scan-history/useScanHistory.selector"

export const ScanDate = (t: TFunction) =>
  function ScanDateComponent(
    date: string,
    record: ReturnType<typeof getScanHistorySelector>["data"][number]
  ) {
    const prefix = "governance.scanHistory.dates."
    const { startDate, endDate, duration } = record.scanDateTooltip

    return (
      <ShowMore
        id={`${record.scanId}-scan-date`}
        label={
          <ShowMore.Label.Component
            className={cn((isNA(record) || isScanning(record)) && styles.text)}
          >
            {date}
          </ShowMore.Label.Component>
        }
      >
        <ShowMore.Component title="Scan Date">
          <ShowMore.Description
            items={[
              { label: t(`${prefix}startDate`), value: startDate },
              { label: t(`${prefix}endDate`), value: endDate },
              {
                label: t(`${prefix}duration`),
                value:
                  duration.length === 0
                    ? "-"
                    : duration
                        .map(({ key, count }) =>
                          t(`${prefix}${key}`, { count })
                        )
                        .join(" ")
              }
            ]}
          />
        </ShowMore.Component>
      </ShowMore>
    )
  }
